export const PRESCRIPTION_STATUS = Object.freeze({
  ACTIVE: 'active',
  PARTIALLY_DISPENSED: 'partially_dispensed',
  FULLY_DISPENSED: 'fully_dispensed',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
});

export const ITEM_KIND = Object.freeze({
  MEDICATION: 'medication',
  LAB: 'lab',
  IMAGING: 'imaging',
});

export const USER_ROLE = Object.freeze({
  ADMIN: 'admin',
  DOCTOR: 'doctor',
  PHARMACY: 'pharmacy',
});

export const SUPPORTED_LOCALES = ['en', 'ar', 'fr'];
export const RTL_LOCALES = ['ar'];
